<template>
  <header class="topbar">
    <div class="header-btn__wrap"
         v-if="homeContent?.platformIntro">
      <a class="header-btn"
         :href="homeContent?.platformIntro?.link || ''"
         target="_blank">
        {{ homeContent?.platformIntro?.title || '' }}
        <svg class="btn__icon"
             fill="none"
             stroke="currentColor"
             viewBox="0 0 24 24"
             stroke-width="2.5">
          <path stroke-linecap="round"
                stroke-linejoin="round"
                d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
        </svg>
      </a>
    </div>

    <div class="section-wrap">
      <router-link class="brand"
                   to="/home">
        <img v-if="homeContent?.pcImage1"
             class="topbar-logo"
             :src="homeContent?.pcImage1"
             alt="logo" />
      </router-link>

      <nav class="t1-nav topbar-desktop">
        <span v-for="item in navList"
              :key="item.href">
          <a v-if="item.href.startsWith('http')"
             :href="item.href"
             target="_blank"
             class="nav-btn">
            {{ item.label }}
          </a>
          <router-link v-else
                       class="nav-btn"
                       :to="item.href">
            {{ item.label }}
          </router-link>
        </span>
      </nav>

      <button class="topbar-mobile-btn"
              type="button"
              aria-label="open menu"
              @click="state.drawerOpen = true">
        <i class="el-icon-s-fold"></i>
      </button>

      <el-drawer :visible.sync="state.drawerOpen"
                 direction="rtl"
                 :with-header="false"
                 size="86%"
                 custom-class="t1-mobile-drawer"
                 append-to-body>
        <div class="t1-drawer-inner">
          <div class="t1-drawer-head">
            <router-link class="brand"
                         to="/home"
                         @click.native="state.drawerOpen = false">
              <img v-if="homeContent?.pcImage1"
                   class="topbar-logo"
                   :src="homeContent?.pcImage1"
                   alt="logo" />
            </router-link>
            <button class="t1-drawer-close"
                    type="button"
                    aria-label="close menu"
                    @click="state.drawerOpen = false">
              <i class="el-icon-circle-close"></i>
            </button>
          </div>

          <nav class="t1-drawer-nav">
            <span v-for="item in navList"
                  :key="item.href"
                  class="t1-drawer-nav-item">
              <a v-if="item.href.startsWith('http')"
                 class="t1-drawer-link"
                 :href="item.href"
                 target="_blank">
                {{ item.label }}
              </a>
              <router-link v-else
                           class="t1-drawer-link"
                           :to="item.href">
                {{ item.label }}
              </router-link>
            </span>
          </nav>
        </div>
      </el-drawer>
    </div>
  </header>
</template>

<script>

export default {
  name: 'HomeTopbar',

  props: {
    excelUrl: {
      type: [String, null],
      default: ''
    },

    homeContent: {
      type: Object,
      default: () => ({})
    },

    platformIntro: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      state: {
        drawerOpen: false
      }
    }
  },
  computed: {
    navList() {
      const arr = [
        { href: '/home', label: 'HOME' },
        { href: '/goods', label: 'PRODUCTS' },
        { href: '/outfits', label: 'OUTFITS' },
      ]

      if (this.excelUrl) {
        arr.push({ href: this.excelUrl, label: 'SPREADSHEET' })
      }

      return arr
    },

  },
  methods: {
    onChangeExpert(platform) {
      this.$emit('change-expert', platform)
    }
  }
}
</script>

<style scoped>
.section-wrap {
  width: min(1400px, 92vw);
  margin: 0 auto;
  padding: 1rem 4rem;
  padding-left: env(safe-area-inset-left, 0);
  padding-right: env(safe-area-inset-right, 0);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.topbar {
  width: 100%;
  max-width: 2000px;
  padding: 0 !important;
  position: relative;
  display: flex;
  flex-direction: column;
  margin-left: auto;
  margin-right: auto;
  isolation: isolate;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  background: transparent;
}

.header-btn__wrap {
  width: 100%;
  background: linear-gradient(to right, rgb(255, 111, 0), rgb(255, 217, 0));
}

.header-btn {
  margin: 0px;
  width: 100%;
  padding: 10px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 1.2;
  color: #fff;
  font-size: 14px;
  font-family: 'Roboto Mono', monospace !important;
  text-align: center;
  transition: all .05s ease-in-out;
}

.header-btn .btn__icon {
  width: 18px;
  height: 18px;
}

.header-btn:hover {
  color: #fff !important;
  transform: translateY(-1px) scale(1.01);
}

.topbar::before {
  content: "";
  position: absolute;
  inset: 0;
  left: 50%;
  width: 100vw;
  transform: translateX(-50%);
  z-index: -1;
  background: var(--background-color);
  border-bottom: 1px solid hsl(from var(--background-color) h s l / 0.09);
  box-shadow: 0 10px 22px hsl(from var(--background-color) h s l / 0.88);
}

@media (max-width: 1200px) {
  .section-wrap {
    padding: 1rem;
    width: 100%;
  }
}

.brand {
  font-family: "Anton", sans-serif;
  color: var(--select-color) !important;
  text-decoration: none;
  letter-spacing: 1.5px;
  font-size: clamp(2rem, 5vw, 2.6rem);
}

.brand:hover {
  color: var(--primary-color) !important;
}

.t1-nav {
  display: flex;
  gap: 1.3rem;
}

.t1-nav a {
  font-family: 'Roboto Mono', monospace;
  color: hsl(from var(--primary-color) h s l / 0.6) !important;
  text-decoration: none;
  text-transform: uppercase;
  font-size: 1rem;
  letter-spacing: 0.07em;
  font-weight: 600;
}

.t1-nav a:hover {
  color: var(--primary-color) !important;
}

.topbar-desktop {
  flex: 1;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1.5rem;
}

.nav-btn {
  color: var(--select-color) !important;
  text-decoration: none;
  text-transform: uppercase;
  font-size: 0.72rem;
  letter-spacing: 0.07em;
}

.nav-btn:hover {
  color: var(--primary-color) !important;
}

.platform-wrap {
  display: flex;
  align-items: center;
}

.topbar-logo {
  height: 40px;
  width: auto;
}

.topbar-mobile-btn {
  display: none;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border: 1px solid var(--select-border-color);
  border-radius: 6px;
  background: transparent;
  color: var(--select-color);
  font-size: 1.1rem;
  cursor: pointer;
}

.topbar-mobile-btn:hover,
.topbar-mobile-btn:focus {
  color: var(--primary-color) !important;
  border: 1px solid var(--primary-color) !important;
}

@media (max-width: 980px) {
  .topbar-desktop {
    display: none !important;
  }

  .brand {
    font-size: clamp(1.35rem, 8vw, 2rem);
  }

  .topbar-logo {
    height: 32px;
    width: auto;
  }

  .topbar-mobile-btn {
    display: inline-flex;
  }
}
</style>

<style lang="scss">
.t1-mobile-drawer {
  .t1-drawer-inner {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 0.7rem 1rem 1.2rem;
    background: var(--background-color);

    .t1-drawer-nav {
      flex: auto;
    }

    .platform-left {
      margin: 0;
    }
  }

  .t1-drawer-head {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 1.2rem;
  }

  .t1-drawer-close {
    border: 0;
    background: transparent;
    color: var(--select-color) !important;
    font-size: 1.45rem;
    cursor: pointer;
  }

  .t1-drawer-nav {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-flex-direction: column;
    flex-direction: column;
    gap: 0.1rem;
  }

  .t1-drawer-nav-item {
    display: block;
  }

  .t1-drawer-link {
    display: -webkit-inline-box;
    display: -webkit-inline-flex;
    display: inline-flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    gap: 0.3rem;
    color: var(--select-color) !important;
    text-decoration: none;
    text-transform: uppercase;
    font-family: "Anton", sans-serif;
    letter-spacing: 0.02em;
    font-size: clamp(2rem, 9vw, 2.7rem);
    line-height: 1.5;
  }

  .t1-drawer-no {
    margin-top: 0.2rem;
    font-style: normal;
    font-family: "JetBrains Mono", ui-monospace, monospace;
    font-size: 0.72rem;
    letter-spacing: 0.02em;
  }
}
</style>
